import useSegment from './use-segment';
/**
 * This allows you to access *any* segment asset giving you the url
 */
export default function useContentAsset(segment, path) {
    const segmentRes = useSegment(segment);
    const asset = segmentRes.assets[path];
    return asset?.content;
}
